import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Item, Product, Summary } from '@models/models';

@Injectable()
export class QuotesDataProvider {
	quoteUpdate: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(private http: HttpClient) {}

	get shouldQuoteBeUpdatedObservable() {
		return this.quoteUpdate.asObservable();
	}

	emitQuoteUpdateEvent(value) {
		return this.quoteUpdate.next(value);
	}

	sendQuoteEmail(data) {
		const formData: FormData = new FormData();
		const { sendMessageData, storedFiles, uploadedFiles } = data;

		for (const key in sendMessageData) {
			if (key !== 'attachmentsData') {
				formData.append(key, sendMessageData[key]);
			}
		}

		for (const key in storedFiles) {
			formData.append(`storedAttachments[${key}]`, storedFiles[key].id);
		}

		for (const key in uploadedFiles) {
			formData.append(`attachments[${key}]`, uploadedFiles[key]);
		}

		return this.sendQuoteEmailRequest(formData);
	}

	getNewQuote(quoteId: number): Observable<any> {
		const url = `/api/user/v1/quote/${quoteId}`;
		return this.http.get(url);
	}

	getQuote(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}`;
		return this.http.get(url);
	}

	getQuoteWeb(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}`;
		return this.http.get(url);
	}

	getQuoteToEdit(
		jobId: number,
		isJob: boolean,
		quoteId: number
	): Observable<any> {
		let url = isJob
			? `/protected/rest/quote/sources?jobId=${jobId}`
			: `/protected/rest/quote/sources?leadId=${jobId}`;

		if (quoteId) {
			url += `&quoteId=${quoteId}`;
		}
		return this.http.get(url);
	}

	deleteQuote(jobId: number, quoteId: number): Observable<any> {
		const url = `/protected/rest/jobs/${jobId}/quote/delete/${quoteId}`;
		return this.http.post(url, {});
	}

	saveQuote(jobId: number, data): Observable<any> {
		const url = `/protected/rest/job/${jobId}/quote/save`;
		return this.http.post(url, data);
	}

	getQuoteToEditV1(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}`;

		return this.http.get(url);
	}

	getJobId(leadId: number): Observable<any> {
		const url = `/api/user/v1/lead/${leadId}/jobId`;
		return this.http.get(url);
	}

	saveQuoteV1(jobId: number, quoteId: number, data): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}`;
		return this.http.put(url, data);
	}

	saveFixedQuoteV1(jobId: number, quoteId: number, data): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/fixed/${quoteId}`;
		return this.http.put(url, data);
	}

	createQuoteV1(jobId: number, data): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote`;
		return this.http.post(url, data);
	}

	createFixedQuoteV1(jobId: number, data): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/fixed`;
		return this.http.post(url, data);
	}

	calculateProductsSummary(
		products: Product[] | Array<Item>,
		tax: number,
		currencySymbol: string
	): Observable<Summary> {
		const url = '/api/public/v1/ui/helper/calculate/summary';
		return this.http.post(url, { products, tax, currencySymbol });
	}

	getQuoteIdAndDate(id: number): Observable<any> {
		const url = `/api/user/v1/job/${id}/quote/template`;
		return this.http.get(url);
	}

	generateInvoiceFromQuote(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}/generate-invoice`;
		return this.http.put(url, null);
	}

	markQuoteAsAccepted(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}/mark-accepted`;
		return this.http.put(url, null);
	}

	updateQuoteActions(jobId: number, quoteId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/quote/${quoteId}/actions`;
		return this.http.get(url);
	}

	sendQuoteEmailRequest(formData: FormData): Observable<Object> {
		const url = '/protected/rest/jobs/quote/send/';
		return this.http.post(url, formData);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/quote/quotes-data-service/quotes.data.service.ts